(function () {

    angular
        .module('ngmvac')
        .directive('onError', OnError);

    function OnError() {
        return {
            link: function (scope, element, attrs) {
                // console.log(attrs, "attrs");
                element.bind('error', function () {
                    var arr = JSON.parse(attrs.onError);
                    var src;
                    angular.forEach(arr, function(item){
                        if(item.imageTypeCode == 'GEN'){
                            src = item.path;
                        }
                    });
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', "https://photos.hotelbeds.com/giata/" + src);
                    }
                });
            }
        }
    }
})();